import apiCaller from 'services/Api/ApiCaller';
import { API_URL } from 'settings';

export interface RealtimeBenchmarkPreview {
  session_id: number;
  window_start: string;
  window_end: string;
  status: 'empty' | 'unavailable' | 'ready';
  dates: string[];
  composite: number[];
  components: {
    key: string;
    ric: string;
    name: string;
    weight: number;
    returns: number[];
    last_price_date: string | null;
    conflicting_dates: string[];
  }[];
  unavailable_components: string[];
}

export async function fetchRealtimeBenchmarkPreview(
  sessionId: number,
  signal: AbortSignal,
): Promise<RealtimeBenchmarkPreview> {
  const response = await apiCaller({
    path: `/sessions/${sessionId}/realtime_benchmark_preview/`,
    method: 'GET',
    apiUrl: API_URL,
    signal,
  });
  if (
    response.status < 200 ||
    response.status >= 300 ||
    response.result?.session_id !== sessionId
  ) {
    throw new Error('Could not load the benchmark return.');
  }
  return response.result as RealtimeBenchmarkPreview;
}
